<app-warning *ngIf="anyExpireWithinNinetyDays">
  <div>
    <p class="h5">
      <strong>This software license will expire in less than 90 days.</strong>
    </p>
    <br>
    <p class="h6">The license term for this item expires {{earliestEndDate | date:'longDate'}}, regardless of
      purchase date.
      A new one-year license will be available for purchase by that date.
    </p>
  </div>
</app-warning>
